import ApiERP from '@/core/conectores/ApiERP';
import { IListaPaginada } from '@/core/models/Consulta/IListaPaginada';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
import { IFiltroRelatorioAnaliseEstoque } from '@/models/Relatorios/Estoque/IFiltroRelatorioAnaliseEstoque';
import { IDadosRelatorioAnaliseEstoque } from '@/models/Relatorios/Estoque/IDadosRelatorioAnaliseEstoque';
import { IDadosRelatorioInventarioPorLote } from '@/models/Relatorios/Estoque/IDadosRelatorioInventarioPorLote';
import { IListaPaginadaRelatorioInventarioPorLote } from '@/models/Relatorios/Estoque/IListaPaginadaRelatorioInventarioPorLote';

/**
 * Serviço de Relatórios de Vendas.
 */

class ServicoRelatorioEstoque {
    endPoint = 'relatorios-estoques';

    apiERP = new ApiERP();

    public requisicaoSistema():void{
      this.apiERP = new ApiERP(true);
    }

    public async obterArquivoAnaliseEstoque(tipoArquivo: ETipoArquivo, filtros: IFiltroRelatorioAnaliseEstoque):Promise<IRetornoRelatorio> {
      const result: any = await this.apiERP.post(`${this.endPoint}/analise-estoque/arquivo/${tipoArquivo}`, filtros);
      return result.data;
    }

    public async obterAnaliseEstoque(filtros: IFiltroRelatorioAnaliseEstoque): Promise<IDadosRelatorioAnaliseEstoque> {
      const result: any = await this.apiERP.post(`${this.endPoint}/analise-estoque`, filtros);
      const listaPaginada = {} as IListaPaginada;
      listaPaginada.metaData = JSON.parse(result.headers['x-paginacao']);
      listaPaginada.dados = result.data.itens;
      result.data.itens = listaPaginada;
      return result.data;
    }

    public async obterArquivoInventarioPorLote(tipoArquivo: ETipoArquivo, filtros: any):Promise<IRetornoRelatorio> {
      const result: any = await this.apiERP.post(`${this.endPoint}/inventario-por-lote/arquivo/${tipoArquivo}`, filtros);
      return result.data;
    }

    public async obterInventarioPorLote(filtros: any): Promise<IDadosRelatorioInventarioPorLote> {
      const result: any = await this.apiERP.post(`${this.endPoint}/inventario-por-lote`, filtros);

      const listaPaginada = {} as IListaPaginadaRelatorioInventarioPorLote;

      if (Array.isArray(result.data)) {
        listaPaginada.dados = result.data;

        if (result.headers && result.headers['x-paginacao']) {
          listaPaginada.metaData = JSON.parse(result.headers['x-paginacao']);
        } else {
          listaPaginada.metaData = {
            totalRegistros: result.data.length,
            qtdeRegistrosPagina: filtros.qtdRegistrosPagina || result.data.length,
            paginaAtual: filtros.numeroPagina || 1,
            totalPaginas: 1,
            possuiProximaPagina: false,
            possuiPaginaAnterior: false,
          };
        }
      } else {
        listaPaginada.dados = [];
        listaPaginada.metaData = {
          totalRegistros: 0,
          qtdeRegistrosPagina: 0,
          paginaAtual: 1,
          totalPaginas: 0,
          possuiProximaPagina: false,
          possuiPaginaAnterior: false,
        };
      }

      return {
        itens: listaPaginada,
      };
    }
}
export default ServicoRelatorioEstoque;
